import React from "react";
import AddLeitnerBoxState, { AddLeitnerBoxProps } from "./AddLeitnerBox.models";
import addLeitnerImage from '../../assest/images/card-image/addLeitner.png'
import './AddLeitnerBox.scss';
import LearningBoxService from "../../services/content/LearningBoxService";
import { Navigate } from "react-router-dom";

export default class AddLeitnerBox extends React.PureComponent<AddLeitnerBoxProps, AddLeitnerBoxState>{
    learningBoxService: LearningBoxService;
    constructor(props: AddLeitnerBoxProps) {
        super(props);
        this.learningBoxService = new LearningBoxService();
        this.state = { createLeitnerBoxDTO: { flashCardCategoryTitle: '', title: '', flashCardCategoryId: null }, redirect: false };
    }

    create = () => {
        let state = this;
        this.learningBoxService.create(this.state.createLeitnerBoxDTO).then(response => {
            // eslint-disable-next-line no-restricted-globals
            state.setState({ redirect: true })
        });
    }

    render(): React.ReactNode {
        // eslint-disable-next-line no-lone-blocks
        return <>
            {this.state.redirect && <Navigate to={"/CustomBoxs"} />}
            <div className="col-12 add-leitner-area">
                <div className="tk-card">
                    <div className="card-icon">
                        <img src={addLeitnerImage} alt="pencil icon" />
                    </div>
                    <div className="card-title">
                        <label>عنوان و دسته بندی جعبه لایتنر</label>
                    </div>
                    <div className="col-12 user-info">
                        <div className="tk-inline">
                            <div className="col-12 notspace">
                                <label>نام جعبه لایتنر</label>
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-12 notspace">
                                <input type={"text"} className="form-control" value={this.state.createLeitnerBoxDTO.title} onChange={e => this.setState((prevState) => {
                                    return { createLeitnerBoxDTO: { ...prevState.createLeitnerBoxDTO, title: e.target.value } }
                                })} placeholder="نام جعبه لایتنر" />
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-12 notspace">
                                <label>دسته بندی کلمات لایتنر</label>
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-12 notspace">
                                <input type={"text"} className="form-control" value={this.state.createLeitnerBoxDTO.flashCardCategoryTitle} onChange={e => this.setState((prevState) => {
                                    return { createLeitnerBoxDTO: { ...prevState.createLeitnerBoxDTO, flashCardCategoryTitle: e.target.value } }
                                })} placeholder="نام دسته ی کلمات" />
                            </div>
                        </div>
                        <div className="tk-inline py-4">
                            <div className="col-12 notspace personal-content-menu-buttons-area" >
                                <button className="btn btn-primary full-width" onClick={this.create} >ثبت</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    }
}